<div
  class="stars-container input"
  [class.disabled]="disabled"
  (mouseleave)="clearHover()"
>
  <button
    *ngFor="let star of stars"
    type="button"
    class="star-button"
    [class.filled]="isFilled(star)"
    [disabled]="disabled"
    [attr.aria-label]="'Select ' + star + ' Star'"
    (mouseenter)="setHover(star)"
    (click)="selectStar(star)"
  >
    ★
  </button>
</div>